import { createAction } from '@reduxjs/toolkit';
import { PropertyExclusiveOffersPage } from 'types/content';

export const setPropertyExclusiveOffersPage = createAction<PropertyExclusiveOffersPage>('content/SET_PROPERTY_EXCLUSIVE_OFFERS_PAGE');
export const fetchPropertyExclusiveOffersPage = createAction<PropertyExclusiveOffersPage>('content/FETCH_PROPERTY_EXCLUSIVE_OFFERS_PAGE');
